<template>
  <div id="success">
    <div class="top">
      <img :src="topImg" alt="" />
    </div>
    <div class="content">
      <p class="tip1">
        <!-- <img :src="require('../assets/success.png')" alt="" /> -->
        <img :src="require('../assets/right.png')" alt="" />
        <!-- 报名成功 -->
      </p>
      <!-- <p class="tip2">为了方便我们更好的为您服务，诚邀您进入群聊</p> -->
      <p>感谢您的报名，请等待我们联系您确认信息</p>
      <!-- <img :src="require('../assets/ewm.png')" alt="" /> -->
      <!-- <p class="tip2">长按识别二维码</p> -->
    </div>
    <div class="bottom">
      <img :src="bottomImg" alt="" />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      topImg: require("@/assets/top.png"),
      bottomImg: require("@/assets/bottom.png"),
    };
  },
};
</script>
<style lang="less" scoped>
#success {
  width: 100vw;
  height: 100vh;
  position: relative;
  animation: show 0.5s ease-in-out 1;
  .top {
    width: 100%;
    img {
      width: 100%;
    }
  }
  .bottom {
    width: 100%;
    img {
      width: 100%;
    }
    position: absolute;
    bottom: 0;
  }
  .content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .tip1 {
      margin-top: 60px;
      font-size: 18px;
      color: rgba(51, 51, 51, 1);
      img {
        width: 70px;
        height: 70px;
        vertical-align: middle;
      }
    }
    .tip2 {
      margin: 20px 0 53px 0;
      font-size: 14px;
      color: rgba(102, 102, 102, 1);
    }
    img {
      width: 160px;
      height: 160px;
    }
  }
}
@keyframes show {
  0% {
    transform: scale(0.5);
  }

  50% {
    margin-top: -50px;
  }

  100% {
    transform: scale(1);
  }
}
</style>
